import { Routes, Route } from "react-router-dom";
import { FaWhatsapp } from "react-icons/fa";
import Navbar from "./components/Navbar/Navbar";
import Home from "./components/Home/Home";
import About from "./components/About/About";
import Footer from "./components/Footer/Footer";
import Contact from "./components/Contact/Contact";
import Works from "./components/OurWorks/OurWorks";
import ScrollToTop from "./components/ScrollToTop";

function App() {
  return (
    <div className="app">
      <ScrollToTop />
      <Navbar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/works" element={<Works />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

      <Footer />

      {/* ===== FLOATING WHATSAPP ICON ===== */}
      <a
        href="https://wa.me/917200809077?text=Hello%20Blessing%20Interiors,%20I%20would%20like%20to%20know%20more%20about%20your%20services."
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
        style={{
          position: "fixed",
          right: "24px",
          bottom: "24px",
          width: "58px",
          height: "58px",
          backgroundColor: "#25D366",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
          zIndex: 9999,
          textDecoration: "none",
        }}
      >
        <FaWhatsapp style={{ color: "#fff", fontSize: "32px" }} />
      </a>
    </div>
  );
}

export default App;
